// Avateal Theme JS

// ── Scroll Reveal ──
const revealObserver = new IntersectionObserver(
  (entries) => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); revealObserver.unobserve(e.target); } }),
  { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
);
document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

// ── Mobile Nav ──
const menuBtn = document.getElementById('mobile-menu-btn');
const mobileNav = document.getElementById('mobile-nav');
if (menuBtn && mobileNav) {
  menuBtn.addEventListener('click', () => {
    mobileNav.classList.toggle('open');
    const open = mobileNav.classList.contains('open');
    menuBtn.setAttribute('aria-expanded', open);
    menuBtn.innerHTML = open
      ? '<svg width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>'
      : '<svg width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="M3 12h18M3 6h18M3 18h18"/></svg>';
  });
}

// ── Filter Tabs ──
document.querySelectorAll('.filter-tab').forEach(tab => {
  tab.addEventListener('click', () => {
    const group = tab.closest('.filter-tabs');
    group.querySelectorAll('.filter-tab').forEach(t => t.classList.remove('active'));
    tab.classList.add('active');
    const filter = tab.dataset.filter;
    const cards = document.querySelectorAll('.product-card[data-category]');
    cards.forEach(card => {
      card.style.display = (filter === 'all' || card.dataset.category === filter) ? '' : 'none';
    });
  });
});

// ── Variant Picker ──
document.querySelectorAll('.variant-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const group = btn.closest('.variant-options');
    group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const hiddenInput = btn.closest('form')?.querySelector('input[name="id"]');
    if (hiddenInput && btn.dataset.variantId) hiddenInput.value = btn.dataset.variantId;
  });
});

// ── Quantity Controls ──
document.querySelectorAll('.qty-input-wrap, .cart-item-qty').forEach(wrap => {
  const input = wrap.querySelector('input');
  const minus = wrap.querySelector('[data-action="minus"]');
  const plus = wrap.querySelector('[data-action="plus"]');
  if (input && minus) minus.addEventListener('click', () => { const v = parseInt(input.value) || 1; input.value = Math.max(1, v - 1); });
  if (input && plus) plus.addEventListener('click', () => { const v = parseInt(input.value) || 1; input.value = v + 1; });
});

// ── Cart Drawer ──
const cartDrawer = document.getElementById('cart-drawer');
const cartOverlay = document.getElementById('cart-drawer-overlay');
const cartClose = document.getElementById('cart-drawer-close');
const cartBody = document.getElementById('cart-drawer-body');
const cartFooter = document.getElementById('cart-drawer-footer');
const cartTotal = document.getElementById('cart-drawer-total');
const cartTimerBar = document.getElementById('cart-drawer-timer-bar');
const cartCountdown = document.getElementById('cart-drawer-countdown');
const drawerItemCount = document.getElementById('drawer-item-count');
let countdownInterval = null;

function startCountdown() {
  let seconds = 10 * 60;
  if (cartTimerBar) cartTimerBar.style.display = 'block';
  clearInterval(countdownInterval);
  countdownInterval = setInterval(() => {
    seconds--;
    const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    if (cartCountdown) cartCountdown.textContent = `${m}:${s}`;
    if (seconds <= 0) clearInterval(countdownInterval);
  }, 1000);
}

function openCartDrawer() {
  cartDrawer.classList.add('open');
  cartOverlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  startCountdown();
}

function closeCartDrawer() {
  cartDrawer.classList.remove('open');
  cartOverlay.classList.remove('open');
  document.body.style.overflow = '';
  clearInterval(countdownInterval);
}

if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

// Open drawer when cart icon is clicked
const cartBtn = document.getElementById('cart-drawer-btn');
if (cartBtn) {
  cartBtn.addEventListener('click', (e) => {
    e.preventDefault();
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        renderCartDrawer(cart);
        openCartDrawer();
      });
  });
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function changeQty(key, newQty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: newQty })
  }).then(r => r.json()).then(cart => renderCartDrawer(cart));
}

function renderCartDrawer(cart) {
  cartBody.innerHTML = '';
  if (drawerItemCount) drawerItemCount.textContent = cart.item_count;

  if (!cart.items || cart.items.length === 0) {
    cartBody.innerHTML = '<p class="cart-drawer-empty">Your cart is empty.</p>';
    if (cartFooter) cartFooter.style.display = 'none';
    if (cartTimerBar) cartTimerBar.style.display = 'none';
    clearInterval(countdownInterval);
    return;
  }

  cart.items.forEach(item => {
    const el = document.createElement('div');
    el.className = 'cart-drawer-item';
    el.innerHTML = `
      <img class="cart-drawer-item-img" src="${item.image}" alt="${item.product_title}">
      <div class="cart-drawer-item-info">
        <div class="cart-drawer-item-top">
          <div class="cart-drawer-item-title">${item.product_title}</div>
          <button class="cart-drawer-item-remove" data-key="${item.key}" aria-label="Remove item">
            <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>
          </button>
        </div>
        <div class="cart-drawer-item-bottom">
          <div class="cart-drawer-qty-row">
            <button class="drawer-qty-btn drawer-qty-minus" data-key="${item.key}" data-qty="${item.quantity}">−</button>
            <span class="drawer-qty-num">${item.quantity}</span>
            <button class="drawer-qty-btn drawer-qty-plus" data-key="${item.key}" data-qty="${item.quantity}">+</button>
          </div>
          <div class="cart-drawer-item-price">${formatMoney(item.final_line_price)}</div>
        </div>
      </div>`;
    cartBody.appendChild(el);
  });

  cartBody.querySelectorAll('.drawer-qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const current = parseInt(btn.dataset.qty);
      const newQty = btn.classList.contains('drawer-qty-plus') ? current + 1 : Math.max(0, current - 1);
      changeQty(btn.dataset.key, newQty);
    });
  });

  cartBody.querySelectorAll('.cart-drawer-item-remove').forEach(btn => {
    btn.addEventListener('click', () => changeQty(btn.dataset.key, 0));
  });

  if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);
  if (cartFooter) cartFooter.style.display = 'flex';

  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = cart.item_count;
    el.style.display = cart.item_count > 0 ? '' : 'none';
  });
}

// ── Add to Cart (AJAX) ──
document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    const btn = form.querySelector('.add-to-cart-btn');
    const originalHTML = btn ? btn.innerHTML : '';
    if (btn) { btn.innerHTML = 'Adding...'; btn.disabled = true; }

    const formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(res => res.json())
    .then(() => fetch('/cart.js'))
    .then(res => res.json())
    .then(cart => {
      renderCartDrawer(cart);
      openCartDrawer();
      if (btn) { btn.innerHTML = 'Added ✓'; btn.disabled = false; }
      setTimeout(() => { if (btn) btn.innerHTML = originalHTML; }, 2000);
    })
    .catch(() => {
      if (btn) { btn.innerHTML = originalHTML; btn.disabled = false; }
    });
  });
});

// ── Newsletter ──
const nlForm = document.getElementById('newsletter-form');
if (nlForm) {
  nlForm.addEventListener('submit', function(e) {
    const success = document.getElementById('newsletter-success');
    if (success) {
      setTimeout(() => { success.style.display = 'block'; nlForm.style.display = 'none'; }, 200);
    }
  });
}

// ── Announcement dismiss ──
const annDismiss = document.getElementById('ann-dismiss');
if (annDismiss) {
  annDismiss.addEventListener('click', () => {
    const bar = document.getElementById('announcement-bar');
    if (bar) bar.style.display = 'none';
  });
}
